import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Pillars } from './components/Pillars';
import { FreeGuide } from './components/FreeGuide';
import { BookSection } from './components/BookSection';
import { WeeklyGuides } from './components/WeeklyGuides';
import { Mission } from './components/Mission';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="bg-richBlack min-h-screen text-warmWhite selection:bg-gold selection:text-richBlack font-montserrat" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Pillars data-id="element-4" />
        <FreeGuide data-id="element-5" />
        <BookSection data-id="element-6" />
        <WeeklyGuides data-id="element-7" />
        <Mission data-id="element-8" />
        <FinalCTA data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}